import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/unauthorized/")({
  component: RouteComponent,
});

function RouteComponent() {
  return <div className="p-32 w-full h-full flex items-center justify-center text-2xl font-bold">Keine Berechtigung</div>;
}
